import React, { useEffect, useMemo, useState } from "react";
import { Grid, Box, Typography } from "@material-ui/core";
import { HomeWorkRounded } from "@material-ui/icons";

import MainLayout from "../components/Layout/MainLayout";
import FactoryList from "../components/Factory/FactoryList";

import { firebaseFetchOneDealer } from "../firebase/dealer";
import { firebaseFetchAllFactories } from "../firebase/factory";
import LoadingState from "../components/Custom/LoadingState";

import Skeleton from "@material-ui/lab/Skeleton";

export default function DealerDetailPage(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { dealerID } = props;

  /**
  |--------------------------------------------------
  | States
  |--------------------------------------------------
  */
  const [dealer, setDealer] = useState({});
  const [factories, setFactories] = useState([]);
  const [isFetchingFactories, setIsFetchingFactories] = useState(true);
  const [errorCode, setErrorCode] = useState(null);
  const [loading, setLoading] = useState(false);

  /**
  |--------------------------------------------------
  | Fetch Dealer & Factories
  |--------------------------------------------------
  */
  useEffect(() => {
    preparePage();
  }, [dealerID]);

  async function preparePage() {
    try {
      setLoading(true);
      setIsFetchingFactories(true);
      setFactories([]);
      const dealer = await firebaseFetchOneDealer(dealerID);

      if (!dealer) {
        setErrorCode(404);
        return;
      }

      setDealer(dealer);
      setLoading(false);
      if (dealer.factories) {
        const factories = await firebaseFetchAllFactories(dealerID);
        setFactories(factories);
      }

      setIsFetchingFactories(false);
    } catch (error) {
      console.error(error);
    }
  }
  /**
  |--------------------------------------------------
  | Breadcrumbs
  |--------------------------------------------------
  */
  const breadcrumbsLoading = useMemo(
    () => [
      {
        to: "/",
        label: "Dashboard",
      },
      {
        to: null,
        label: <Skeleton width={100} height={20} />,
      },
    ],
    [dealer]
  );

  const breadcrumbs = useMemo(
    () => [
      {
        to: "/",
        label: "Dashboard",
      },
      {
        to: null,
        label: dealer.name,
      },
    ],
    [dealer]
  );

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */

  return (
    <MainLayout
      breadcrumbs={loading ? breadcrumbsLoading : breadcrumbs}
      errorCode={errorCode}
      dealerID={dealerID}
    >
      <Grid container>
        <Box
          bgcolor="grey.800"
          display="flex"
          width="100%"
          flexDirection="column"
          p={3}
          mt={3}
          borderRadius="borderRadius"
        >
          <Grid
            item
            xs={12}
            container
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={6} container>
              <Box color="grey.600" mr={2}>
                <HomeWorkRounded />
              </Box>
              <Typography>Factory List</Typography>
            </Grid>
          </Grid>
          <Box xs={12} mt={3} /> {/* GAP */}
          <Grid item xs={12}>
            {isFetchingFactories ? (
              <LoadingState />
            ) : (
              <FactoryList
                factories={factories}
                setIsFetchingFactories={setIsFetchingFactories}
                preparePage={preparePage}
                dealerID={dealerID}
              />
            )}
          </Grid>
        </Box>
      </Grid>
    </MainLayout>
  );
}
